<template>
  <div class="teacher-contract-list p-2">
    <avue-crud
      ref="crud"
      :option="option"
      :data="data"
      :page.sync="page"
      :table-loading="loading"
      @on-load="onLoad"
      @search-change="searchChange"
      @refresh-change="refreshChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-upload" @click="openUploadModal">上传合同</el-button>
      </template>
      <template slot="teacher" slot-scope="{row}">
        <span>{{ row.teacher && row.teacher.name ? row.teacher.name : '未知讲师' }}</span>
      </template>
      <template slot="contractPeriod" slot-scope="{row}">
        <span v-if="row.contractPeriod">
          {{ row.contractPeriod.start | formatDate }} - {{ row.contractPeriod.end | formatDate }}
        </span>
      </template>
      <template slot="contractSrc" slot-scope="{row}">
        <el-link v-if="row.contractSrc" :href="row.contractSrc" target="_blank" type="primary">查看合同</el-link>
      </template>
    </avue-crud>

    <!-- Upload Dialog -->
    <el-dialog title="上传合同" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="form" ref="form" label-width="100px" :rules="rules">
        <el-form-item label="讲师" prop="teacher">
          <el-select
            v-model="form.teacher"
            filterable
            remote
            reserve-keyword
            placeholder="请输入讲师姓名搜索"
            :remote-method="remoteMethod"
            :loading="teacherLoading"
            style="width: 100%">
            <el-option
              v-for="item in teacherOptions"
              :key="item._id"
              :label="item.name"
              :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签署日期" prop="signDate">
          <el-date-picker
            v-model="form.signDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同期限" prop="contractPeriod">
          <el-date-picker
            v-model="form.contractPeriod"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同文件" prop="file">
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            accept=".pdf,.doc,.docx,.jpg,.png"
            :auto-upload="false"
            :on-change="handleFileChange"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">支持pdf/doc/docx/jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="uploading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as dayjs from 'dayjs';

export default {
  name: 'TeacherContractList',
  data() {
    return {
      data: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      option: {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        align: 'center',
        menuAlign: 'center',
        searchMenuSpan: 6,
        column: [
          {
            label: '讲师姓名',
            prop: 'teacher',
            slot: true,
            search: true,
            searchSpan: 6,
            searchTitle: '讲师姓名',
            searchValue: ''
          },
          {
            label: '签署日期',
            prop: 'signDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            label: '合同期限',
            prop: 'contractPeriod',
            slot: true,
            search: true,
            searchSpan: 6,
            type: 'daterange',
            searchRange: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期'
          },
          {
            label: '上传时间',
            prop: 'uploadTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: '合同文件',
            prop: 'contractSrc',
            slot: true
          }
        ]
      },
      dialogVisible: false,
      form: {
        teacher: '',
        signDate: '',
        contractPeriod: [],
        file: null
      },
      fileList: [],
      teacherOptions: [],
      teacherLoading: false,
      uploading: false,
      rules: {
        teacher: [{ required: true, message: '请选择讲师', trigger: 'change' }],
        signDate: [{ required: true, message: '请选择签署日期', trigger: 'change' }],
        contractPeriod: [{ required: true, message: '请选择合同期限', trigger: 'change' }],
      },
      searchParams: {}
    };
  },
  filters: {
    formatDate(val) {
      if (!val) return '';
      return dayjs(val).format('YYYY-MM-DD');
    }
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true;
      const searchData = { ...this.searchParams, ...params };
      const query = {
        limit: page.pageSize,
        page: page.currentPage,
        sort: { uploadTime: -1 },
        where: {}
      };

      try {
        if (searchData.teacher) {
          const res = await this.$http.get('teachers', {
            params: {
              query: JSON.stringify({
                where: {
                  name: { $regex: searchData.teacher, $options: 'i' }
                }
              })
            }
          });
          const teacherIds = res.data.data.map(t => t._id);
          if (teacherIds.length > 0) {
            query.where.teacher = { $in: teacherIds };
          } else {
            query.where.teacher = '000000000000000000000000';
          }
        }

        if (searchData.contractPeriod && searchData.contractPeriod.length === 2) {
          query.where['contractPeriod.start'] = { $gte: searchData.contractPeriod[0] };
          query.where['contractPeriod.end'] = { $lte: searchData.contractPeriod[1] };
        }

        this.fetchData(query);
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    fetchData(query) {
      this.$http.get('teacher-contracts', {
        params: {
          query: JSON.stringify(query)
        }
      }).then(res => {
        this.data = res.data.data;
        this.page.total = res.data.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    searchChange(params, done) {
      this.page.currentPage = 1;
      this.searchParams = params;
      this.onLoad(this.page, params);
      done();
    },
    refreshChange() {
      this.onLoad(this.page, this.searchParams);
    },
    openUploadModal() {
      this.dialogVisible = true;
      this.form = { teacher: '', signDate: '', contractPeriod: [], file: null };
      this.fileList = [];
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleFileChange(file, fileList) {
      const isValidType = /\.(pdf|doc|docx|jpg|png)$/i.test(file.name);
      if (!isValidType) {
        this.$message.error('只能上传 pdf/doc/docx/jpg/png 文件!');
        this.fileList = [];
        this.form.file = null;
        return;
      }
      this.fileList = fileList.slice(-1); // Keep only one
      this.form.file = file.raw;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.form.file = null;
    },
    remoteMethod(query) {
      if (query !== '') {
        this.teacherLoading = true;
        this.$http.get('teachers', {
          params: {
            query: JSON.stringify({
              where: {
                name: { $regex: query }
              },
              limit: 20
            })
          }
        }).then(res => {
          this.teacherOptions = res.data.data;
          this.teacherLoading = false;
        });
      } else {
        this.teacherOptions = [];
      }
    },
    async submitUpload() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (!this.form.file) {
            this.$message.error('请选择合同文件');
            return;
          }

          this.uploading = true;
          try {
            // 1. Upload to OSS
            const formData = new FormData();
            formData.append('file', this.form.file);
            const uploadRes = await this.$http.post('upload', formData);
            
            // Check response structure. Assuming it returns { url: '...' } or similar.
            // Based on AppController, it returns { name: ..., ...file }.
            // The file object from Multer-OSS usually has 'url' or 'path'.
            const fileUrl = uploadRes.data.url || uploadRes.data.path || uploadRes.data.location; 
            
            if (!fileUrl) {
                throw new Error('Upload failed, no URL returned');
            }

            // 2. Save metadata
            const payload = {
              teacher: this.form.teacher,
              signDate: this.form.signDate,
              contractPeriod: {
                start: this.form.contractPeriod[0],
                end: this.form.contractPeriod[1]
              },
              contractSrc: fileUrl,
              uploadTime: new Date()
            };

            await this.$http.post('teacher-contracts/create-with-link', payload);
            
            this.$message.success('上传成功');
            this.dialogVisible = false;
            this.refreshChange();
          } catch (e) {
            console.error(e);
            this.$message.error('上传失败: ' + (e.message || 'Unknown error'));
          } finally {
            this.uploading = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.teacher-contract-list {
    background: #fff;
    border-radius: 4px;
}
</style>
